import { Box, Typography, Stack, Grid } from '@mui/material';
import { Phone, Email, WhatsApp, Chat, LocalShipping } from '@mui/icons-material';
import ContactCard from './ContactCard';
import { brandingConfig } from '@/config/branding';
import { useTranslation } from '../../../kit/useTranslation';

export default function ContactSection({ onContact, isDesktop = false }) {
  const { t } = useTranslation();
  const contactOptions = [
    {
      icon: Phone,
      title: t('support.phoneSupport'),
      subtitle: t('support.available247'),
      color: '#4caf50',
      type: 'phone',
    },
    {
      icon: WhatsApp,
      title: t('support.whatsapp'),
      subtitle: t('support.quickResponse'),
      color: '#25D366',
      type: 'whatsapp',
    },
    {
      icon: Email,
      title: t('support.email'),
      subtitle: brandingConfig.contact.supportEmail,
      color: '#2196f3',
      type: 'email',
    },
    {
      icon: LocalShipping,
      title: 'Pilot Portal',
      subtitle: 'Join our rider network',
      color: '#FF9800',
      type: 'pilot',
    },
    {
      icon: Chat,
      title: t('support.liveChat'),
      subtitle: t('support.chatWithTeam'),
      color: '#9c27b0',
      type: 'chat',
    },
  ];

  if (isDesktop) {
    return (
      <Stack spacing={2}>
        {contactOptions.map((option, index) => (
          <ContactCard
            key={index}
            icon={option.icon}
            title={option.title}
            subtitle={option.subtitle}
            color={option.color}
            onClick={() => onContact(option.type)}
          />
        ))}
      </Stack>
    );
  }

  return (
    <Box sx={{ px: 2, mb: 3 }}>
      <Typography variant="h6" fontWeight={700} gutterBottom>
        {t('support.contactUs')}
      </Typography>
      <Stack spacing={2}>
        {contactOptions.map((option, index) => (
          <ContactCard
            key={index}
            icon={option.icon}
            title={option.title}
            subtitle={option.subtitle}
            color={option.color}
            onClick={() => onContact(option.type)}
          />
        ))}
      </Stack>
    </Box>
  );
}
